import { getLink } from '../../../utils/utils';
import img1 from '../../images/al_konata_pentristo_img1.jpg';
import img2 from '../../images/al_konata_pentristo_img2.jpg';
import img3 from '../../images/al_konata_pentristo_img3.jpg';

import author from './author';

const content = {
  esp: (
    `
    
    <div class="poem">
      <p class="poem-block mb-3">
        Pentristo apud fenestro,<br/>
        Pentrestro apud montrilo<br/>
        Rigardas per longa rigardo<br/>
        Al Primorskij bulvardo
      </p>
      
      <div class="text-center mb-3">
        <img src=${img1} />
      </div>

      <p class="poem-block mb-3">
        Kaj vidas arbedojn florajn,<br/>
        Teatrajn kupolojn glorajn,<br/>
        Blankantajn ŝipojn en maro,<br/>
        Grizplatojn de la Ŝtuparo,
      </p>
      
      <p class="poem-block mb-3">
        Kaj super ĉio, senlima,<br/>
        Penetris lian animon<br/>
        Klara ĉiela blueco –<br/>
        Amika mesaĝ’ de Odeso.
      </p>

      <div class="text-center mb-3">
        <img src=${img2} />
      </div>

      <p class="poem-block mb-3">
        Magistro kaj grandmaestro,<br/>
        L’Pentristo, de la fenestro<br/>
        Foriras al pentrostablo<br/>
        Kaj el tuta sia kapablo
      </p>

      <p class="poem-block mb-3">
        Komencas pentri portreton<br/>
        De sia propra persono,<br/>
        Ĉar sole ĝin li ne vidis<br/>
        En ĉirkaŭanta mondo.
      </p>
    </div>
    
    
    <div class="text-center mb-5">
      <img src=${img3} />
    </div>
    `
  )
}

const itemName = {
  esp: 'Al konata pentristo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}


export default item;